@if (showDashboard) {
  <div class="dashboard-wrapper">
    <!-- POWERLINES layout: Project on left, Workerteam on right -->
    @if (customerId === customerIds.POWERLINES) {
      <nav
        class="navbar navbar-expand project-select d-flex justify-content-between align-items-center cursor-pointer">
        <div class="project dropdown" ngbDropdown>
          <a href="javascript:void(0)" id="projectDropdownMenuButton" ngbDropdownToggle>
            <div class="project-menu d-flex align-items-center">
              <span class="projectName">{{currentProject}}</span>
              <img class="ms-2" src="assets/icons/expand_more_gray_24dp.svg">
            </div>
          </a>
          <ul class="project-dropdown dropdown-menu dropdown-menu-end" ngbDropdownMenu>
            @for (item of projects; track $index) {
              <li id="projectDropdownMenuItems">
                <button class="dropdown-item" ngbDropdownItem
                (click)="switchProject(item.id)">{{item.name}}</button>
              </li>
            }
          </ul>
        </div>
        <div class="d-flex align-items-center">
          <span class="me-2">{{ 'fieldReporting.dashboard.filterBy' | translate }}:</span>
          <div class="project dropdown" ngbDropdown>
            @if (currentWorkerteam) {
              <a href="javascript:void(0)" ngbDropdownToggle>
                <div class="project-menu d-flex align-items-center">
                  <div class="d-flex align-items-center">
                    <div class="workerteam-info">
                      <div class="workerteam-name fw-bold">{{currentWorkerteam.values.name}}</div>
                      @if (currentWorkerteam.values.status_name) {
                        <div class="text-muted small">{{currentWorkerteam.values.status_name}}</div>
                      }
                    </div>
                    <div class="done-count ms-1">
                      <span class="badge bg-secondary">
                        {{ doneOrders?.length }}/{{ workOrdersInCalendar?.length }}
                      </span>
                    </div>
                  </div>
                  <img class="ms-2" src="assets/icons/expand_more_gray_24dp.svg">
                </div>
              </a>
            }
            @if (!currentWorkerteam) {
              <h2>{{'workers.noWorkerteamsFound' | translate }}</h2>
            }
            <ul class="project-dropdown dropdown-menu dropdown-menu-end" ngbDropdownMenu>
              @for (item of workerteams; track $index) {
                <li id="workerteamsDropdownMenuItems">
                  @if (item.show) {
                    <button class="dropdown-item" ngbDropdownItem (click)="switchWorkerteam(item.id)">
                      <div>{{item.values.name}}</div>
                      @if (item.values.status_name) {
                        <div class="text-muted small">{{item.values.status_name}}</div>
                      }
                    </button>
                  }
                </li>
              }
            </ul>
          </div>
        </div>
      </nav>
    }
    <!-- Original layout for other customers -->
    @if (customerId !== customerIds.POWERLINES) {
      <nav class="navbar navbar-expand ps-3 project-select cursor-pointer">
        <div class="project dropdown" ngbDropdown>
          <a href="javascript:void(0)" id="projectDropdownMenuButton2" ngbDropdownToggle>
            <div class="project-menu d-flex align-items-center">
              <span class="projectName">{{currentProject}}</span>
              <img class="ms-2" src="assets/icons/expand_more_gray_24dp.svg">
            </div>
          </a>
          <ul class="project-dropdown dropdown-menu dropdown-menu-end" ngbDropdownMenu>
            @for (item of projects; track $index) {
              <li id="projectDropdownMenuItems">
                <button class="dropdown-item" ngbDropdownItem
                (click)="switchProject(item.id)">{{item.name}}</button>
              </li>
            }
          </ul>
        </div>
        <!-- Workerteam dropdown + done/scheduled (right) -->
        <div class="project dropdown ms-auto" ngbDropdown>
          <!-- Toggle: current team + badge -->
          @if (currentWorkerteam) {
            <a href="javascript:void(0)" ngbDropdownToggle>
              <div class="project-menu d-flex align-items-center">
                <div class="workerteam-info">
                  <div class="workerteam-name fw-bold">{{ currentWorkerteam.values.name }}</div>
                  @if (currentWorkerteam.values.status_name) {
                    <div class="text-muted small">{{ currentWorkerteam.values.status_name }}</div>
                  }
                </div>
                <div class="done-count ms-1">
                  <span class="badge bg-secondary">
                    {{ doneOrders?.length }}/{{ workOrdersInCalendar?.length }}
                  </span>
                </div>
                <img class="ms-2" src="assets/icons/expand_more_gray_24dp.svg">
              </div>
            </a>
          }
          <!-- Fallback: no teams -->
          @if (!currentWorkerteam) {
            <h2>
              {{ 'workers.noWorkerteamsFound' | translate }}
            </h2>
          }
          <!-- Dropdown items: all teams -->
          <ul class="project-dropdown dropdown-menu dropdown-menu-end" ngbDropdownMenu>
            @for (item of workerteams; track $index) {
              <li id="workerteamsDropdownMenuItems">
                @if (item.show) {
                  <button class="dropdown-item" ngbDropdownItem (click)="switchWorkerteam(item.id)">
                    <div>{{ item.values.name }}</div>
                    @if (item.values.status_name) {
                      <div class="text-muted small">{{ item.values.status_name }}</div>
                    }
                  </button>
                }
              </li>
            }
          </ul>
        </div>
      </nav>
    }
    <div class="dual-container">
      <nav class="workerteam navbar navbar-expand left">
        <app-search (onChange)="onSearchChange($event)" (onClick)="onSearchClick($event)"
          (onLocationClick)="onSearchLocationClick($event)" [reset]="resetSearch" [strictSearch]="false"
          [showExtraInfo]="false" [resetWhenClickedOutside]="true" [workOrders]="workOrders">
        </app-search>
      </nav>
    </div>
    @if (customerId === customerIds.POWERLINES) {
      <div class="dual-container multi-filter-container">
        <div [ngStyle]="{ background: assignedOnlyChecked ? 'blue' : 'transparent', color: assignedOnlyChecked ? 'white' : '#007bff' }"
          class="assigned-only checkbox-button">
          <label>
            <input type="checkbox" [checked]="assignedOnlyChecked" [disabled]="reportedOnlyChecked"
              (change)="onAssignedOnlyChange($event)" />
            {{ 'fieldReporting.dashboard.showOnlyAssignedToMyTeam' | translate }}
          </label>
        </div>
        <div class="workerteam-status">
          <div [ngStyle]="{ background: reportedOnlyChecked ? 'blue' : 'transparent', color: reportedOnlyChecked ? 'white' : '#007bff' }"
            class="reported-only checkbox-button">
            <label>
              <input type="checkbox" [checked]="reportedOnlyChecked" [disabled]="assignedOnlyChecked"
                (change)="onReportedOnlyChange($event)" />
              {{ 'fieldReporting.dashboard.selectWorkerTeamStatus' | translate }}
            </label>
          </div>
        </div>
      </div>
    }
    <div class="main">
      <nav class="nav justify-content-between pt-3">
        <a class="ms-3 nav-tab" [ngStyle]="styleObject(0)" (click)="tabChanger(0)">{{'fieldReporting.dashboard.map' | translate}}</a>
        <a class="me-3 nav-tab" [ngStyle]="styleObject(3)" (click)="tabChanger(3)">{{'basic.done' | translate }}</a>
      </nav>
      <hr>
        <div [hidden]="tab !== 0" class="map-height">
          <div #mapmap id="mapmap" class="map-container structure-child">
            <!-- Work Order Details View -->
            @if (selectedWorkOrder) {
              <div class="workorder-details-container pb-5 d-flex flex-column">
                <div class="dual-container">
                  <div class="left">{{'basic.selected' | translate}}</div>
                  <div class="close-icon-container right">
                    <img src="assets/icons/close_gray_24dp.svg" alt="Close" (click)="closeDetails()"
                      class="close-icon">
                  </div>
                </div>
                <div class="inner-workorder-details p-2 w-100">
                  <div class="workorder-text-details">
                    <div class="fw-bold blue-text">{{'fieldReporting.dashboard.details' | translate}}
                      <div class="d-flex">
                        <p class="col-6">ID:
                          @if (customerId !== 2 && customerId !== 4 && customerId !== 3) {
                            <span
                            class="gray-text">{{ selectedWorkOrder.id }}</span>
                          }
                          @if (customerId === 2 && selectedWorkOrder.transformer) {
                            <span
                              class="gray-text">{{ selectedWorkOrder.transformer }} -
                              {{selectedWorkOrder.inverter}}@if (selectedWorkOrder.circuit) {
                              <span> -
                              {{selectedWorkOrder.circuit}}</span>
                            }</span>
                          }
                          @if (customerId === 2 && !selectedWorkOrder.transformer) {
                            <span
                            class="gray-text">{{selectedWorkOrder.identifier}}</span>
                          }
                          @if (customerId === 3 || customerId === 4) {
                            <span
                            class="gray-text">{{selectedWorkOrder.identifier}}</span>
                          }
                        </p>
                        <div class="buttons col-6 d-flex justify-content-end">
                          @if (customerId === 3) {
                            <button class="btn btn-secondary"
                              (click)="toSingleWorkOrder(selectedWorkOrder, currentWorkerteam.id, 'view')">
                              {{'fieldReporting.dashboard.viewReports' | translate}}
                            </button>
                          }
                          @if (customerId !== customerIds.POWERLINES && showUpdateButton(selectedWorkOrder, true)) {
                            <button
                              (click)="toSingleWorkOrder(selectedWorkOrder, currentWorkerteam.id, 'update')"
                            class="btn btn-primary btn-sm">{{'fieldReporting.dashboard.updateReport' | translate}}</button>
                          }
                          @if (customerId !== customerIds.POWERLINES && showCreateButton(selectedWorkOrder)) {
                            <button
                              (click)="toSingleWorkOrder(selectedWorkOrder, currentWorkerteam.id, 'create')"
                            class="btn btn-primary btn-sm">{{'fieldReporting.dashboard.createReport' | translate}}</button>
                          }
                        </div>
                      </div>
                      <p>{{'fieldReporting.dashboard.status' | translate}}: <span class="gray-text">
                        {{ customerId === customerIds.POWERLINES
                        ? getPowerlineStatusName(selectedWorkOrder)
                        : getStatusName(selectedWorkOrder.status_id)
                        }}
                      </span></p>
                      <p>{{'fieldReporting.dashboard.notes' | translate}}: <span class="gray-text">{{ selectedWorkOrder.notes }}</span></p>
                    </div>
                    <!-- Interruptions list -->
                    @if (selectedWorkOrderInterruptions.length) {
                      <div (click)="showInterruptionsToggle()"
                        class="show-interruption-reports row cursor-pointer">
                        <div class="col-12 reports-count ps-2 text-center">
                          {{ showInterruptions
                          ? ('fieldReporting.dashboard.hideInterruptions' | translate)
                          : ('fieldReporting.dashboard.interruptions' | translate) + ' (' +
                          selectedWorkOrderInterruptions?.length + ')'
                          }}
                        </div>
                      </div>
                    }
                    <div class="interruption-list" [ngClass]="{'expanded': showInterruptions}">
                      @if (selectedWorkOrderInterruptions?.length) {
                        <div>
                          @for (interruption of selectedWorkOrderInterruptions; track $index) {
                            <div class="report-row">
                              <div class="row">
                                <div class="col-4 fw-bold ps-0 text-primary fw-bold">
                                  {{ interruption.status }}
                                </div>
                                <div class="col-8 fw-bold ps-0">
                                  {{ formatReportDateTime(interruption.created) }}
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-4 fw-bold ps-0">
                                  <span class="text-primary fw-bold">ID:</span>
                                  {{ interruption.id }}
                                </div>
                                <div class="col-8 fw-bold ps-0">
                                  <img src="assets/icons/person_blue_24dp.svg" alt="Reporter"
                                    class="close-icon">
                                  {{ interruption.attendee_name }}
                                </div>
                              </div>
                              @if (interruption.notes) {
                                <div class="row">
                                  <div class="col-12 ps-0">
                                    <h4 class="reason-for-interruption pb-0 mb-0 fw-bold">
                                      {{ 'fieldReporting.dashboard.reasonForInterruption' | translate }}:
                                    </h4>
                                    {{ interruption.notes }}
                                  </div>
                                </div>
                              }
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </div>
                <button type="button" class="mobile-close-details btn btn-secondary w-100"
                  (click)="closeDetails()">
                  {{ 'fieldReporting.dashboard.close' | translate }}
                </button>
              </div>
            }
            <!-- Base Details View -->
            @if (selectedBase) {
              <div class="workorder-details-container pb-5 d-flex flex-column">
                <div class="dual-container">
                  <div class="left">{{ 'fieldReporting.dashboard.selectedBase' | translate }}</div>
                  <div class="close-icon-container right">
                    <img src="assets/icons/close_gray_24dp.svg" alt="Close" (click)="closeDetails()"
                      class="close-icon">
                  </div>
                </div>
                <div class="inner-workorder-details p-2 w-100">
                  <div class="workorder-text-details">
                    <div class="fw-bold blue-text">{{ 'fieldReporting.dashboard.details' | translate }}
                      <div class="d-flex">
                        <span class="col-12">
                          Id: {{ selectedBase.id }}
                        </span>
                      </div>
                      <div class="d-flex">
                        <div class="col-6">
                          @if (selectedBase.identifier) {
                            <p>{{'planner.routePlanning.base' | translate}}:
                              @if (selectedBase.identifier) {
                                <span class="gray-text">{{
                                selectedBase.identifier }}</span>
                              }
                            </p>
                          }
                        </div>
                        <div class="buttons col-6 d-flex justify-content-end">
                          <button (click)="createBaseReport(selectedBase, currentWorkerteam.id)"
                            class="btn btn-primary btn-sm">
                            {{ 'fieldReporting.dashboard.createReport' | translate }}
                          </button>
                        </div>
                      </div>
                      <p>{{ 'fieldReporting.dashboard.notes' | translate }}: <span class="gray-text">{{
                      selectedBase.notes }}</span></p>
                    </div>
                    <!-- selected report details -->
                    @if (selectedBaseReport) {
                      <div class="selected-report-details mt-3">
                        <div class="report-details-header d-flex justify-content-between align-items-center mb-2">
                          <h6 class="fw-bold mb-0">{{ 'fieldReporting.dashboard.reportDetails' | translate }}
                          </h6>
                          <button class="btn btn-sm btn-secondary" (click)="closeSelectedBaseReport()">
                            {{ 'fieldReporting.dashboard.backToList' | translate }}
                          </button>
                        </div>
                        <div class="report-info p-2 bg-light rounded">
                          <p class="mb-1"><strong>{{ 'fieldReporting.dashboard.date' | translate }}:</strong>
                        {{ formatReportDateTime(selectedBaseReport.attend_time) }}</p>
                        <p class="mb-1"><strong>{{ 'basic.name' | translate }}:</strong> {{
                      selectedBaseReport.name || 'N/A' }}</p>
                      <p class="mb-1"><strong>{{ 'fieldReporting.dashboard.reportedBy' | translate
                      }}:</strong> {{ selectedBaseReport.attendee_name || 'Unknown' }}</p>
                      <p class="mb-2"><strong>{{ 'fieldReporting.dashboard.notes' | translate }}:</strong>
                    {{ selectedBaseReport.notes || 'No notes' }}</p>
                    <!-- Loading images -->
                    @if (loadingBaseReportImages) {
                      <div class="text-center py-3">
                        <div class="spinner-border text-primary" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                        <div class="mt-2">
                          <small class="text-muted">{{ 'fieldReporting.dashboard.loadingImages' |
                          translate }}</small>
                        </div>
                      </div>
                    }
                    <!-- Images loaded -->
                    @if (!loadingBaseReportImages) {
                      <div>
                        @if (selectedBaseReport.images && selectedBaseReport.images.length > 0) {
                          <div>
                            <strong>{{ 'fieldReporting.dashboard.images' | translate }} ({{
                            selectedBaseReport.images.length }}):</strong>
                            <div class="d-flex flex-wrap gap-2 mt-2">
                              @for (image of selectedBaseReport.images; track $index) {
                                <div>
                                  <img [src]="image.img" class="report-image"
                                    alt="Report image" (click)="openInModal(imageModal, image)">
                                </div>
                              }
                            </div>
                          </div>
                        }
                        @if (!selectedBaseReport.images || selectedBaseReport.images.length === 0) {
                          <div
                            >
                            <small class="text-muted fst-italic">{{
                            'fieldReporting.dashboard.noImagesAttached' | translate }}</small>
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
              }
              <!-- report list -->
              @if (!selectedBaseReport && selectedBaseReports?.length) {
                <div>
                  <div (click)="showBaseReportsToggle()" class="show-base-reports row cursor-pointer">
                    <div class="col-6 reports-count ps-2">
                      {{ selectedBaseReports?.length }} {{ 'fieldReporting.dashboard.reports' |
                      translate }}
                    </div>
                    <div class="col-6 text-right reports-toggle pe-2">
                      {{ showBaseReports
                      ? ('fieldReporting.dashboard.hideReports' | translate)
                      : ('fieldReporting.dashboard.showReports' | translate)
                      }}
                      <img [src]="showBaseReports ? 'assets/icons/expand_less_gray_24dp.svg' : 'assets/icons/expand_more_gray_24dp.svg'"
                        class="toggle-arrow" alt="Toggle">
                    </div>
                  </div>
                  <div class="base-reports-list" [ngClass]="{'expanded': showBaseReports}">
                    @if (selectedBaseReports && selectedBaseReports.length > 0) {
                      <div>
                        @for (report of selectedBaseReports; track $index) {
                          <div
                            class="report-row row cursor-pointer"
                            (click)="viewBaseReport(report, selectedBase)">
                            <div class="col-6 fw-bold ps-0">
                              {{ formatReportDateTime(report.attend_time) }}
                            </div>
                            <div class="col-6 pe-0">
                              {{ report.name }}
                            </div>
                          </div>
                        }
                      </div>
                    }
                    @if (!selectedBaseReports || selectedBaseReports.length === 0) {
                      <div
                        class="no-reports-message">
                        {{ 'fieldReporting.dashboard.noReportsAvailable' | translate }}
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
          <button type="button" class="mobile-close-details btn btn-secondary w-100"
            (click)="closeDetails()">
            {{ 'fieldReporting.dashboard.close' | translate }}
          </button>
        </div>
      }
    </div>
  </div>
  @if (tab === 3) {
    <div>
      <div class="pt-2">
        <div class="ml-5 pb-1 row justify-content-between">
          <div class="col-4">
            <span class="bold-text">{{tabTitle}}</span>
            <span class="gray-text"> ({{displayedWorkOrders.length}})</span>
          </div>
        </div>
        @if (displayedWorkOrders.length > 0 && !this.workOrdersLoading) {
          <div>
            @for (item of displayedWorkOrders; track $index) {
              <div class="content sharp-shadow rounded-card-sm mb-2"
                [ngClass]="{'reserved': item.reserver_id && item.reserver_id != this.userid}">
                <div class="p-2">
                  <div (click)="toSingleWorkOrder(item, currentWorkerteam.id, 'done')"
                    [ngClass]="{ 'cursor-pointer': showUpdateButton(item) }">
                    <div class="dual-container p-1">
                      <div class="left text-uppercase">
                        <div class="text-lowercase fw-bold">
                          <span class="text-capitalize">{{'basic.workorder' | translate }}</span>
                          @if (item.identifier) {
                            <span class="ml-1">{{item.identifier}}</span>
                          }
                          @if (item.id) {
                            <span class="ml-1">({{item.id}})</span>
                          }
                        </div>
                      </div>
                      <div class="right">
                        <img class="corner-icon" [src]=setCornerIcon(item.access_type)>
                      </div>
                    </div>
                    <hr class="mt-2 mb-2">
                    <div class="row p-1">
                      <div class="col-12 col-sm-auto mb-1 mb-sm-0">
                        <span>{{'fieldReporting.dashboard.reported' | translate }}:</span>
                      </div>
                      <div class="col-12 col-sm d-flex align-items-center mb-1 ps-0 date-time-container">
                        <img class="card-icon dp24" src="assets/icons/today_blue_24dp.svg">
                        @if (item.report_date) {
                          <span>{{ formatReportDate(item.report_date) }}</span>
                        }
                        <img class="card-icon dp24 ms-2" src="assets/icons/schedule_blue_24dp.svg">
                        @if (item.report_date) {
                          <span>{{ formatReportTime(item.report_date) }}</span>
                        }
                        @if (!item.report_date) {
                          <span class="red-text">-</span>
                        }
                      </div>
                    </div>
                    <div class="row p-1">
                      <div class="col-12 col-sm-auto mb-1 mb-sm-0">
                        <span>{{'fieldReporting.dashboard.scheduled' | translate }}:</span>
                      </div>
                      <div class="col-12 col-sm d-flex align-items-center flex-wrap ps-0 date-time-container">
                        <div class="d-flex align-items-center me-2">
                          <img class="card-icon dp24" src="assets/icons/today_blue_24dp.svg">
                          @if (item.starttime) {
                            <span>{{timeWindowToDate(item.starttime)}}</span>
                          }
                          @if (!item.starttime) {
                            <span class="red-text">{{'fieldReporting.shared.missingDate' | translate }}</span>
                          }
                        </div>
                        <div class="d-flex align-items-center">
                          <img class="card-icon dp24" src="assets/icons/schedule_blue_24dp.svg">
                          @if (item.starttime) {
                            <span>{{timeWindowToHours(item.starttime)}}</span>
                          }
                          @if (!item.starttime) {
                            <span class="red-text">XX:XX</span>
                          }
                          <span class="mx-1">-</span>
                          @if (item.endtime) {
                            <span>{{timeWindowToHours(item.endtime)}}</span>
                          }
                          @if (!item.endtime) {
                            <span class="red-text">XX:XX</span>
                          }
                        </div>
                      </div>
                    </div>
                    <div class="p-1 d-flex">
                      <img class="dp24" src="assets/icons/location_on_blue_24dp.svg">
                      <div class="mt-1">{{item.latitude}}, {{item.longitude}}</div>
                    </div>
                    <div class="p-1 d-flex">
                      <div class="mt-1">
                        {{ customerId === customerIds.POWERLINES
                        ? getPowerlineStatusName(item)
                        : getStatusName(item.status_id) }}
                      </div>
                    </div>
                    <hr>
                    </div>
                    @if (item.notes || item.worker_notes) {
                      <div>
                        <hr>
                          <div class="blue-text dual-container mb-2">
                            <details class="w-100" (click)="expandArrowListener(item.id)">
                              <summary class="dual-container">
                                <div class="left d-flex">
                                  <img class="card-icon" src="assets/icons/info_blue_24dp.svg">
                                  <h6 class="m-0 lh-body">{{'fieldReporting.dashboard.extraRemarks' |
                                  translate }}</h6>
                                </div>
                                <img id="arrowImg-{{item.id}}" class="right"
                                  src="assets/icons/expand_more_blue_24dp.svg">
                                </summary>
                                <div class="ms-4 mt-2">
                                  <div [hidden]="!item.worker_notes">
                                    <div>{{'fieldReporting.shared.extraInformationCallingService' |
                                      translate }}
                                    </div>
                                    <p class="gray-text">{{item.worker_notes}}</p>
                                  </div>
                                  <div [hidden]="!item.notes">
                                    <div>{{'fieldReporting.shared.extraInformationPlanner' | translate }}
                                    </div>
                                    <p class="gray-text">{{item.notes}}</p>
                                  </div>
                                </div>
                              </details>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
              @if (this.workOrdersLoading) {
                <div class="pt-2">
                  <div class="ms-5 pb-2">{{'fieldReporting.dashboard.loading' | translate }}</div>
                </div>
              }
              @if (displayedWorkOrders.length == 0 && !this.workOrdersLoading) {
                <div class="pt-2">
                  <div class="ms-5 pb-2">{{'fieldReporting.dashboard.noWorkordersFound' | translate }}</div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }

  <!-- Image Modal -->
  <ng-template #imageModal let-modal>
    <div class="modal-header">
      <h5 class="modal-title">{{ 'fieldReporting.dashboard.image' | translate }}</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
    </div>
    <div class="modal-body text-center">
      <img [src]="currentImg?.img" style="max-width: 100%; height: auto;" alt="Full size image" />
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="closeModal()">{{ 'fieldReporting.dashboard.close' |
      translate }}</button>
    </div>
  </ng-template>
  <!-- Route Note Modal -->
  <div #routeNotesModal class="modal fade" id="routeNotesModal" tabindex="-1" aria-labelledby="routeNotesModalLabel"
    aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title" id="routeNotesModalLabel">
          @if (routeNoteMode === 'CREATE') {
            {{'fieldReporting.dashboard.createNewRouteNote' | translate }}
          }
          @if (routeNoteMode === 'EDIT' || routeNoteMode === 'DELETE') {
            {{'fieldReporting.dashboard.editRouteNote' | translate }}
          }
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body">
        @if (routeNoteMode === 'CREATE') {
          <textarea id="createRouteNoteText" class="form-control" rows="5" [(ngModel)]="routeNoteText"
          placeholder=""></textarea>
        }
        @if (routeNoteMode === 'EDIT' || routeNoteMode === 'DELETE') {
          <textarea id="editRouteNoteText" class="form-control" rows="5" [(ngModel)]="routeNoteText"
          placeholder=""></textarea>
        }
      </div>

      <div class="modal-footer">
        @if (routeNoteMode !== 'DELETE') {
          <button type="button" class="btn btn-secondary"
            data-bs-dismiss="modal">
            {{'basic.close' | translate }}
          </button>
        }
        @if (routeNoteMode === 'CREATE') {
          <button (click)="createRouteNote()" type="button"
            class="btn btn-primary">
            {{'basic.add' | translate }}
          </button>
        }
        @if (routeNoteMode === 'EDIT') {
          <button (click)="deleteRouteNote()" type="button"
            class="btn btn-danger">
            {{'basic.delete' | translate }}
          </button>
        }
        @if (routeNoteMode === 'EDIT') {
          <button (click)="editRouteNote()" type="button"
            class="btn btn-primary">
            {{'basic.save' | translate }}
          </button>
        }

        @if (routeNoteMode === 'DELETE') {
          <span>{{'fieldReporting.dashboard.deleteRouteNote' | translate
          }}</span>
        }
        @if (routeNoteMode === 'DELETE') {
          <button (click)="confirmDeleteRouteNote()" type="button"
            class="btn btn-danger">
            {{'basic.yes' | translate }}
          </button>
        }
        @if (routeNoteMode === 'DELETE') {
          <button (click)="dismissDeleteRouteNote()" type="button"
            class="btn btn-secondary">
            {{'basic.no' | translate }}
          </button>
        }
      </div>

    </div>
  </div>
</div>
